import './Projects.css'
import Project from './Project'
import data from './data.json'

const Projects = ()=> {
  const projects = data.map(project => {
    return <Project
      title = {project.title}
      description = {project.description}
      image = {project.image}
      live = {project.live}
      github = {project.github}
      tech ={project.tech}
      />
  })
  return (
    <div id="projects">
      <div id="projects-intro">
        <div id="projects-title"> Projects</div>
        <div id="projects-tagline"> Some of the projects I have worked on. </div>
      </div>
      {projects}
    </div>
  );
}
export default Projects;

